<template>
<a :class="['cupn-item', 'cupn-item__click', {'reward': item.flag_promo}, {'opacity': item.opacity}]" @click="goProductPage($event, item.url)" :title="item.name" :data-pid="item.pid" @touchstart="handleItemStart($event, item)" @touchmove="handleItemMove($event, item)" @touchend="handleItemEnd(item)" :style="cupnItemStyle">
  <div class="photo">
    <img class="cupnimg" :src="image_url" :alt="item.name" @error="imgFail(image_url)">
  </div>
  <div class="info">
    <div class="cupn">
      <h3 class="name">{{ item.name }}</h3>
      <!-- <div class="cupn_block">
        <div class="cupn_t">個人對品折價券</div>
        <div class="cupn_ticket">
          <div class="cupn_price">{{ priceFormat(item.discount)}}</div>
        </div>
      </div> -->
    </div>
    <!-- <div class="nor">
      <div class="nor_t">市價</div>
      <div class="nor_price">{{ priceFormat(item.list_price)}}</div>
    </div> -->
    <div class="dis">
      <div class="dis_net"></div>
      <div class="dis_net">
        <div class="dis_af">網路價</div>
        <div class="dis_af_price">{{ priceFormat(item.price)}}</div>
      </div>
      <!-- <div class="dis_net">
        <div class="dis_t">網路價</div>
        <div class="dis_price">{{ priceFormat(item.price)}}</div>
      </div> -->
      <!-- <img src="@/assets/cupn_arrow.svg">
      <div class="dis_net">
        <div class="dis_af">折後</div>
        <div class="dis_af_price">{{ priceFormat(item.after_discount)}}</div>
      </div> -->
    </div>
  </div>
</a>
</template>

<script>
export default {
  name: 'item',
  data() {
    return {
      clientX: 0,
      clientMoveX: 0,
      clientDistanceX: 0,
      styleLeft: '',
      image_url: '',
      pushDisWork: 30,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": this.$cookies.get('_ga_BRVPB1BSBT')
      },
    }
  },
  created() {
    this.image_url = this.item.image_url
  },
  updated() {
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isAiApiFetch: {
      type: Boolean,
      default: () => false
    },
    trackCode: {
      type: String,
      default: () => ''
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    isScrolling: {
      type: Boolean,
      default: () => false
    },
    isShowPidRec: {
      type: Boolean,
      default: () => false
    },
    mobileCircleFetId: {
      type: Boolean,
      default: () => null
    }
  },
  watch: {
    item(n) {
      this.image_url = n.image_url
    }
  },
  methods: {
    goProductPage(evt, url) {
      evt.preventDefault();
      if (!/mobi(le)?/i.test(navigator.userAgent)) {
        url = url.replace('m.shopping.friday.tw/mobileweb/', 'shopping.friday.tw/ec2/')
      }

      // Append CHANNEL ID3 Code
      url += '&WT.me_id=' + this.trackCode

      // 帶上fetId
      if (this.mobileCircleFetId) {
        url += '&fetId=' + this.mobileCircleFetId
      }

      // 心生活遠傳幣再轉轉來源 使用同放大折ID7規則
      if (this.trackCode === 'mobilecircle_AI') {
        // 3/1之後開始同步和 2倍放大折一致
        if (new Date().getTime() > new Date('2023/3/1').getTime()) {
          url += '&WT.mg_id=fetmc_appbonus'
        }
      }

      if (window.self !== window.top) {
        window.top.location.href = url
      } else {
        window.sessionStorage.setItem('bsBack', 1)
        window.location.href = url
      }
    },
    handleItemStart(e, params) {
      if (this.isMobile && !params.flag_promo && !this.isScrolling) {
        this.clientX = e.touches[0].clientX
      }
    },
    handleItemMove(e, params) {
      if (this.isMobile && !params.flag_promo && !this.isScrolling) {
        this.clientMoveX = e.touches[0].clientX
        this.clientDistanceX = Math.floor(this.clientX - this.clientMoveX)

        if (this.pushDisWork < Math.abs(this.clientDistanceX) && Math.abs(this.clientDistanceX) < 240) {
          let dis = this.clientDistanceX < 0 ? this.clientDistanceX + this.pushDisWork : this.clientDistanceX - this.pushDisWork
          this.styleLeft = (0 - dis) + 'px'
        }
      }
    },
    handleItemEnd(params) {
      if (!params.flag_promo && this.isMobile) {
        if (!this.isAiApiFetch && !this.isScrolling) {
          if (Math.abs(this.clientDistanceX) > this.pushDisWork && !this.isLoadPidAI) {
            if (this.isShowPidRec) {
              this.$emit('revertRecItems')
            } else {
              this.$emit('getCategoryRec', this.item.auto_category_id)
            }
          }

        }
        this.clientX = this.clientDistanceX = this.clientMoveX = 0
        this.styleLeft = '0px'
      }
    },
    imgFail(img) {
      fetch('https://mservice-event.shopping.friday.tw/api/imgBase64', {
          method: 'POST',
          headers: this.headers,
          body: JSON.stringify({
            img_path: img
          })
        }).then(res => res.json())
        .then(data => {
          if (data.status === 1) {
            this.image_url = data.base64
          }
        })
    },
    priceFormat(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
  },
  computed: {
    cupnItemStyle() {
      return {
        'left': this.styleLeft
      }
    }
  }
}
</script>

<style>

</style>
